import './vendor/js/jquery.matchHeight-min.js';

$(window).scroll(function () {
  scrollEvent();
  return this;
});

function scrollEvent() {
  let $root,scrollY;
  $root = $(document.documentElement);
  scrollY = $(window).scrollTop();
  if (scrollY > 20) {
    $root.attr('data-scrolled', true);
  } else {
    $root.attr('data-scrolled', false);
  }
};

